<template>
	<div>
		<div class="mb-4">Order Validity</div>

		<div>
			<DropdownSimple v-model="validity" :options="options" placeholder="Select order validity" :full="true" />
		</div>

		<div v-if="validity == 'GTD'" class="mt-5">
			<InputDate v-model="limitOrderDate" :fullWidth="true" :min="minExpiryDateInInput" />
		</div>

		<div v-if="false">
			<div class="flex justify-between items-center">

				<div class="c-select-box rounded">
					<span>
						{{ validity == 'GTC' ? 'Until Cancel' : 'For Date / Time' }}
					</span>
					<select class="c-select" v-model="validity">
						<option value="GTC">Until Cancel</option>
						<option value="GTD">For Date / Time</option>
					</select>
				</div>
			</div>

			<div v-if="validity == 'GTD'" class="flex justify-between items-center mb-2">
				<div class="text-left">Expire Date</div>
				<input type="datetime-local" name="" class="rounded c-input c-date-picker" v-model="limitOrderDate"
					:min="minExpiryDateInInput" onkeydown="return false" />
			</div>
		</div>
	</div>
</template>

<script>
import DropdownSimple from '../DropdownSimple.vue'
import InputDate from '../InputDate.vue'

export default {
	name: 'OrderValidity_TradeTicket',

	components: {
		DropdownSimple,
		InputDate
	},

	data() {
		return {
			validity: '',
			limitOrderDate: '',

			options: [
				{ value: 'GTC', label: "Until Cancel" },
				{ value: 'GTD', label: "Until Date / Time" }
			]
		}
	},

	computed: {
		minExpiryDateInInput() {
			const dateNow = new Date()

			const day = dateNow.getDate() < 10 ? '0' + dateNow.getDate() : dateNow.getDate()
			const month = dateNow.getMonth() + 1 < 10 ? '0' + (dateNow.getMonth() + 1) : dateNow.getMonth() + 1
			const year = dateNow.getFullYear() < 10 ? '0' + dateNow.getFullYear() : dateNow.getFullYear()

			const dateTemp = year + '-' + month + '-' + day

			return dateTemp
		},
	},

	watch: {
		validity(newValue) {
			this.$emit('update:validity', newValue)
		},

		limitOrderDate(newValue) {
			this.$emit('update:limitOrderDate', newValue)
		}
	},

}
</script>